module.exports = new __parcel__URL__("native-issue-table-skeleton.tpl.32b8869a.svg").toString();